import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { getHandleConnectorForDoor } from '../../utils/handlePlacement';
import { PlannerValidation } from './PlannerValidation';
export class HandlePlacementValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'HandlePlacementValidation');
    }
    validateCurrentState(entity) {
        return this.validate(entity, undefined);
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        return this.validate(entity, snapActionCandidate);
    }
    validate(entity, snapActionCandidate) {
        if (!entity.hasComponent(ComponentIds.HANDLE_COMPONENT_ID)) {
            return this.validationOK();
        }
        const parent = snapActionCandidate ? snapActionCandidate.host : HierarchyUtils.parent(entity);
        if (!parent) {
            return this.validationFail('No snapActionCandidate host or parent found');
        }
        // Check if the front is part of a drawer assembly
        const drawerAssembly = HierarchyUtils.findWithComponentInUpwardsHierarchy(parent, ComponentIds.DRAWER_COMPONENT_ID);
        // Get the connection to the front and the handle connection from the snap action candidate
        // This is the connection it will try to use, if the connection is declined then the next one will be tested
        const frontConnection = this.getFrontConnection(snapActionCandidate, entity);
        const handleConnection = this.getHandleConnection(snapActionCandidate, entity);
        const handleOffsetPlacement = 20;
        const handleLength = entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size?.height;
        const frontHeight = parent.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size?.height;
        const frontWidth = parent.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size?.width;
        if (handleLength === undefined || frontHeight === undefined || frontWidth === undefined) {
            return this.validationFail('Can´t get measurement');
        }
        // If it's not a drawer we should not use the drawer attach points
        if (!drawerAssembly) {
            const connectorToUseOnDoor = getHandleConnectorForDoor(parent, entity);
            const maxHandleSizeForConnector = connectorToUseOnDoor
                ?.tags()
                .find(tag => tag.includes('max-handle-height'))
                ?.split(':')[1];
            const handleSizeOk = maxHandleSizeForConnector
                ? handleLength <= Number.parseInt(maxHandleSizeForConnector)
                : handleLength + handleOffsetPlacement < frontHeight;
            if (frontConnection &&
                handleConnection &&
                connectorToUseOnDoor &&
                this.isDoorConnection(frontConnection) &&
                connectorToUseOnDoor.key === frontConnection.key &&
                handleSizeOk) {
                return this.validationOK();
            }
            else {
                return this.validationFail('Couldn´t place handle on door');
            }
        }
        if (frontConnection &&
            handleConnection &&
            this.isDrawerConnection(frontConnection) &&
            handleLength + handleOffsetPlacement < frontWidth) {
            return this.validationOK();
        }
        else {
            return this.validationFail('Couldn´t place handle on drawer');
        }
    }
    isDoorConnection(connector) {
        return (connector.tags().includes('door-handle-attach') ||
            connector.tags().includes('door-handle-attach-edge'));
    }
    isDrawerConnection(connector) {
        return (connector.tags().includes('drawer-handle-attach') ||
            connector.tags().includes('drawer-handle-attach-edge'));
    }
    getFrontConnection(snapActionCandidate, entity) {
        if (!snapActionCandidate) {
            // If there is no snapActionCandidate the handle is validated on it's current location, e.g. on replace.
            // Then get connection from child connection component instead.
            const connection = entity.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
            if (connection?.highestPriorityConnection) {
                return connection.highestPriorityConnection.hostConnector;
            }
        }
        else {
            // The host connector is the front
            return snapActionCandidate.hostConnector;
        }
    }
    getHandleConnection(snapActionCandidate, entity) {
        if (!snapActionCandidate) {
            // If there is no snapActionCandidate the handle is validated on it's current location, e.g. on replace.
            // Then get connection from child connection component instead.
            const connection = entity.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
            if (connection?.highestPriorityConnection) {
                return connection.highestPriorityConnection.guestConnector;
            }
        }
        else {
            // The guestConnector is the handle
            return snapActionCandidate.guestConnector;
        }
        return null;
    }
}
//# sourceMappingURL=HandlePlacementValidation.js.map